export const DATES = [
  { id: "2025-12-22", label: "Mon 22", full: "Dec 22" },
  { id: "2025-12-23", label: "Tue 23", full: "Dec 23" },
  { id: "2025-12-24", label: "Wed 24", full: "Xmas Eve" },
  { id: "2025-12-25", label: "Thu 25", full: "Christmas" },
];

export const CATEGORIES = [
  {
    id: "house",
    label: "House Reset",
    style: "border-[#1F6F54] text-[#1F6F54] bg-[#EAF4EF]",
  },
  {
    id: "kids",
    label: "Kids",
    style: "border-[#1F6F54] text-[#1F6F54] bg-white",
  },
  {
    id: "gifts",
    label: "Gifts",
    style: "border-amber-600 text-amber-700 bg-amber-50",
  },
  {
    id: "food",
    label: "Food & Drink",
    style: "border-[#1F6F54] text-[#1F6F54] bg-white",
  },
  {
    id: "family",
    label: "Extended Family",
    style: "border-[#1F6F54] text-[#1F6F54] bg-white",
  },
  {
    id: "logistics",
    label: "Logistics",
    style: "border-stone-400 text-stone-600 bg-stone-50",
  },
  {
    id: "self",
    label: "Self Care",
    style: "border-rose-300 text-rose-700 bg-rose-50",
  },
];

export const INITIAL_TASKS = [
  // --- MONDAY / TUESDAY / WEDNESDAY TASKS ---
  // (Empty by default now, populated by User inputs or Cards)

  // --- THURSDAY DEC 25 (THE REAL SCHEDULE) ---
  // These drive the list view if you ever toggle off the Timeline,
  // but mostly serve as data structure for the day.
  {
    id: "xmas_1",
    day: "2025-12-25",
    title: "Video Call: Nana (Canada) & Mom",
    category: "family",
    owner: "both",
    timeWindow: "6:02 AM Sharp",
    doneLooksLike: "Video link shared, iPad set up in living room.",
    status: "todo",
    priority: "high",
    notes: "Start the day with connection before the chaos.",
  },
  {
    id: "xmas_2",
    day: "2025-12-25",
    title: "Fuel: Coffee & Cinnamon Rolls",
    category: "food",
    owner: "both",
    timeWindow: "6:15 AM",
    doneLooksLike: "Fresh coffee made, rolls warm.",
    status: "todo",
    priority: "medium",
    notes: "",
  },
  {
    id: "xmas_3",
    day: "2025-12-25",
    title: "Gift Opening & Chaos",
    category: "gifts",
    owner: "both",
    timeWindow: "6:30 AM - 8:00 AM",
    doneLooksLike: "90 minutes of joy.",
    status: "todo",
    priority: "high",
    notes: "",
  },
  {
    id: "xmas_4",
    day: "2025-12-25",
    title: "Post-Opening Cleanup",
    category: "house",
    owner: "all",
    timeWindow: "8:00 AM - 9:00 AM",
    doneLooksLike: "Wrapping paper trashed, boxes recycled.",
    status: "todo",
    priority: "medium",
    notes: "All hands on deck.",
  },
  {
    id: "xmas_5",
    day: "2025-12-25",
    title: "Kids 'Haul' Time / House Reset",
    category: "house",
    owner: "you",
    timeWindow: "9:00 AM - 12:00 PM",
    doneLooksLike: "House back to normal while kids do TikToks.",
    status: "todo",
    priority: "medium",
    notes: "Get the house ready to be left empty.",
  },
  {
    id: "xmas_6",
    day: "2025-12-25",
    title: "Final Packing (Sleepover)",
    category: "logistics",
    owner: "both",
    timeWindow: "12:00 PM",
    doneLooksLike: "Bags packed for Nana & Papa's.",
    status: "todo",
    priority: "medium",
    notes: "",
  },
  {
    id: "xmas_7",
    day: "2025-12-25",
    title: "Light Lunch",
    category: "food",
    owner: "both",
    timeWindow: "12:30 PM",
    doneLooksLike: "Everyone fed before the car ride.",
    status: "todo",
    priority: "medium",
    notes: "",
  },
  {
    id: "xmas_8",
    day: "2025-12-25",
    title: "Load Dogs & Car",
    category: "logistics",
    owner: "you",
    timeWindow: "1:30 PM",
    doneLooksLike: "Dogs secured, bags in trunk.",
    status: "todo",
    priority: "high",
    notes: "",
  },
  {
    id: "xmas_9",
    day: "2025-12-25",
    title: "Depart for Parents",
    category: "logistics",
    owner: "both",
    timeWindow: "1:45 PM",
    doneLooksLike: "Wheels rolling to hit 2pm arrival.",
    status: "todo",
    priority: "high",
    notes: "Hard deadline.",
  },
];
